import React from 'react';
import ReactDOM from 'react-dom';


import DoubleNegative from './DoubleNegative.js';
import Shame from './Shame.js';
import Simple from './Simple.js';
import Neither from './Neither.js';
import Timing from './Timing.js';
import TouchDown from './TouchDown.js';
import SmallPrint from './SmallPrint.js';
import MultiColumn from './MultiColumn.js';
import SneakySub from './SneakySub.js';
import ColorCode from './ColorCode.js';
import Hair from './Hair.js';
import ThreeButtons from './ThreeButtons.js';
import TwoButtons from './TwoButtons.js';
import Spin from './Spin.js';
import MenuMaze from './MenuMaze.js';

import Language from './Language.js';

import Assistant from './Assistant.js';

import List from './List.js';

import IQ from './IQ.js';

import Shade from './Shade.js';

import TrickyBox from './TrickyBox.js';

import RyanAir from './RyanAir.js';


let setResult = false;
let getPos = false;



const QuestionType = {
	LOGICAL: "logical",
	SPEEDY: "speedy",
	LANGUAGE: "language",
	SNEAKY: "sneaky",
    EASY: "easy",
    HARD: "hard",
}





export default function(setResult, getPos) {

    

    let round = [
        


        


       

     



        <Simple 

        types={[QuestionType.EASY]}
    
                      
        question={<p><h2>Thanks for visiting EVIL CORP<br></br><br></br>Our customers are the most important thing to us. We want to give you the best experience possible!<br></br><br></br>Do you agree to the terms & conditions?</h2></p>}
        
        text0="No"
        color0="success"

        text1="Yes"
        color1="danger"

        correct_answer={0}

        

        fail_message="Evil Corp tricked you... by asking you to accept their terms and conditions. Try a bit harder!"
        setResult={setResult}

        getPos={getPos}
      
      ></Simple>,



     
      
  


      <DoubleNegative 

      position={0}

      types={[QuestionType.LANGUAGE]}
              
                  
      question="Would you_____like to_____receive our newsletter?"
      nots1={0}
      nots2={1}
      fail_message="Evil Corp got you with a double degative. Often companies will pose two questions in opposite forms hoping to catch you out with at least one of them."
      setResult={setResult}

      getPos={getPos}

  ></DoubleNegative>,



      <Simple 

      
        
       types={[QuestionType.SNEAKY, QuestionType.EASY]}

                      
        question="Do you agree to the terms & conditions?"
        text0="No"
        color0="success"

        text1="Yes"
        color1="danger"

        correct_answer={0}

        fail_message="Evil Corp tricked you with a decoy colour, using usually negative colours like Red on buttons to accept."
        setResult={setResult}

        getPos={getPos}
      
      ></Simple>,





      


        /*
      <Simple 
    
                      
      question="Would you like to enable third party cookies? At most one of the following three buttons is true."
      text0="This is the Opt-Out Button"
      color0="success"

      text1="The Opt Out Button is BLUE"
      color1="danger"

      correct_answer={0}


      fail_message="Evil Corp eneabled cookies by making it unclear which button rejects cookies. This is a common tactic on many websites."
      
      setResult={setResult}

      getPos={getPos}
    
    ></Simple>,
        */


     
     

          
      <Timing 

      types={[QuestionType.SPEEDY]}

                        
      question="Do you agree to the terms & conditions?"
      text0="Yes"
      color0="success"

      text1="No"
      color1="danger"

      interval={500}

      correct_answer={1}

      fail_message="Evil Corp caught you out by switching the usual positions of yes and no"
      
      setResult={setResult}

      getPos={getPos}
    
    ></Timing>,

    


     <Neither 


     types={[QuestionType.SNEAKY]}

                      
      question="Do you agree to the terms & conditions?"
     
      fail_message="Evil Corp got you by making all of the obviously available options accept the terms and conditions"
      
      setResult={setResult}

      getPos={getPos}
    
      ></Neither>,









                       
        <Assistant 

        types={[QuestionType.LOGICAL, QuestionType.HARD]}
                
                                
        question="One of these buttons will accept the terms and conditions, the other one will not. We have provided two assistants to help you decide. One of them always tells the truth, the other one always lies."
        text0="Yes"
        color0="success"

        text1="No"
        color1="danger"

        correct_answer={1}

        

        fail_message="Evil Corp caught you out by making it impossible to complete your task without contacting them"
        setResult={setResult}

        getPos={getPos}
    
    ></Assistant>,


    

        <Shame 

        types={[QuestionType.EASY]}

                                        
        question="Do you want to receive our newsletter?"
        num_insults={1}
        fail_message="Evil Corp got you by shaming you into accepting their newsletter. This is a very common tactic"
        setResult={setResult}

        getPos={getPos}

    ></Shame>,




    <TrickyBox 

    types={[QuestionType.LOGICAL]}
        
                        
    question="Untick all checkboxes to reject Terms and Conditions. When you tap on a checkbox, all the checkboxes change status apart from the one you tapped."

    text0="Yes"
    color0="success"


    fail_message="Evil Corp got you by using so many checkboxes you just couldn't be bothered to uncheck them all."
    setResult={setResult}

    getPos={getPos}

    ></TrickyBox>,






        <MenuMaze 

        types={[QuestionType.EASY]}

            m0={2}
            m1={1}
            m2={1}
            m3={3}
                        
            question="We will assume you agree to the Terms and conditions if you do not select '_____' from the menu"
            
            correct_item="Reject Ts and Cs"

            fail_message="Evil Corp got you by hiding the item you want within seeminly unrelated submenus."
            
            setResult={setResult}

            getPos={getPos}
        
        ></MenuMaze>,






           
      <TwoButtons 

      types={[QuestionType.LOGICAL]}

      position={0}
                          
      question="Please enable third party cookies. At most one of the following two buttons is true."

      text0="This is the opt-out button"
      color0="primary"

      text1="The opt out button is black"
      color1="success"

      correct_answer={1}

      fail_message="Evil Corp eneabled cookies by making it unclear which button rejects cookies. This is a common tactic on many websites."
      setResult={setResult}

      getPos={getPos}

      ></TwoButtons>,
        



                    
        

        <DoubleNegative 

        types={[QuestionType.LANGUAGE]}

        position={0}
                
                    
        question="To opt out of opting in to_____receive marketing alerts avoid_____clicking Yes"
        nots1={0}
        nots2={1}
        fail_message="Evil Corp caught you out with cunning double negatives."
        setResult={setResult}

        getPos={getPos}

    ></DoubleNegative>,




    <RyanAir 


    types={[QuestionType.SNEAKY]}

                    
    question="Choose country to agree to the Terms and Conditions"


    correct_answer1="DO NOT ACCEPT Ts & Cs"


    correct_answer2="NO THANKS! Reject Ts & Cs"

    correct_answer3="REJECT THE Ts & Cs PLEASE"

    



    fail_message="Evil Corp got you by hiding the reject option in a drop down list of countries. This technique was used by RyanAir to serupticiously add travel insurance to their customers' flights."
    setResult={setResult}

    getPos={getPos}

    ></RyanAir>,
                

                <MultiColumn 

                types={[QuestionType.SPEEDY]}

                    position={0}
                                
                    question="Do you agree to the terms & conditions?"
                    text0="Yes"
                    color0="success"

                    text1="No"
                    color1="danger"

                    correct_answer={1}

                    fail_message="Evil Copy got you to agree to their Ts & Cs by making it overly easy to accidentally tap accept instead of reject."
                    setResult={setResult}

                    getPos={getPos}
                
                ></MultiColumn>,




        <IQ 

        types={[QuestionType.LOGICAL]}
    
                    
        question="To turn off notifications, select the square that comes next in the sequence."
       

        fail_message="Evil Corp turned on notifications by hiding the correct check box."
        setResult={setResult}

        getPos={getPos}
    
    ></IQ>,
    

                <Shame 

                types={[QuestionType.EASY]}

                                    
                    question="Do you want to receive our newsletter?"
                    num_insults={9}
                    fail_message="Evil Corp shamed you into accepting their newsletter by forcing you to choose between signing up or clicking a button that makes you feel bad. This is a standard practice on many websites."
                    setResult={setResult}

                    getPos={getPos}
                
                ></Shame>,

     
            <ColorCode 

            types={[QuestionType.LANGUAGE]}
            
            position={0}
                                
            question="Hello this is Evil Corp. We would really very much like to you to accept our terms and conditions so that we can be closer and look after you better. Would you mind at all clicking the appropriate button to make that happen? We hope these instructions have been clear."
            
            text0="i agree"
            color0="danger"

            text1="no thanks"
            color1="info"

            correct_answer={1}

            fail_message="Evil Corp got you to agree to the terms and conditions using a hidden message"
            setResult={setResult}

            getPos={getPos}

            ></ColorCode>,




                   
            <Shade 


            types={[QuestionType.SNEAKY]}
        
                        
                question="Click the darkest button to unsubscribe"
                text0="Click"

                text1="Click"

                correct_answer={0}

                

                fail_message="Evil Corp used an optical illusion to sign you up to their newsletter"
                setResult={setResult}

                getPos={getPos}
            
            ></Shade>,





            <Simple 

            types={[QuestionType.EASY]}

            position={0}
                            
                question="Help! I'm stuck in a terms and conditions factory. Please accept the terms and conditions to release me."
                text0="Accept"
                color0="success"

                text1="No way"
                color1="danger"

                correct_answer={1}

                fail_message="Evil Corp pretended to be a person stuck in a Ts and Cs factory. As far as we know this has not been used by any other website, yet."
                setResult={setResult}

                getPos={getPos}
            
            ></Simple>,


        

           
            <Language 
                
            types={[QuestionType.LANGUAGE]}
                                
            questions={[

                {language: "Basque", text: "Ados zaude baldintzekin?", button0: "Bai", button1: "Ez", flag: "../images/flags/basque.jpg"},
                {language: "Turkish", text: "Şartlar ve koşulları kabul ediyor musunuz?", button0: "Evet", button1: "Hayır", flag: "../images/flags/turkish.jpg"},
                {language: "Hungarian", text: "Elfogadja a felhasználási feltételeket?", button0: "Igen", button1: "Nem", flag: "../images/flags/hungarian.jpg"},
                {language: "Klingon", text: "mabvam DaQochbe''a'?", button0: "HIja'", button1: "ghobe’", flag: "../images/flags/klingon.jpg"},

            ]}

            correct_answer={1}


            fail_message="Evil Corp forced you to accept Ts and Cs in your non-native language."
            setResult={setResult}

            getPos={getPos}
        
        ></Language>,





        <SneakySub 

        types={[QuestionType.SNEAKY]}
                      
        question="We would like to send you notifications."
        sub="Do you disagree to receiving them?"
        
        text0="Yes"
        color0="danger"

        text1="No"
        color1="success"

        correct_answer={0}

        fail_message="Evil Corp turned on notifications by hiding their real question in a sub-question"
        setResult={setResult}

        getPos={getPos}
    
    ></SneakySub>,


    

                <Simple 

                types={[QuestionType.LANGUAGE]}

                position={0}
                                
                question="Do you agree to the terms & conditions?"
                text0="-.-- . ..."
                color0="success"

                text1="-. ---"
                color1="danger"

                correct_answer={1}

                fail_message="Evil Corp forced you to accept Ts and Cs in your non-native language (Morse code)"
                setResult={setResult}

                getPos={getPos}
                
                ></Simple>,





            
                <SmallPrint 

                types={[QuestionType.SNEAKY]}

                        position={0}
                                        
                        question="Please click yes to agree to the Terms and Conditions. "
                        
                        text0="Or No to decline"
                        color0="success"

                        text1="Yes"
                        color1="success"

                        correct_answer={0}

                        fail_message="Evil Corp got you to accept the terms and conditons by hiding the reject button"
                        setResult={setResult}

                        getPos={getPos}
                    
                    ></SmallPrint>,


                      <Hair 

                      types={[QuestionType.SNEAKY]}

                        position={0}
                                    
                        question="Do you agree to the terms & conditions?"
                        text0="No thank you"
                        color0="danger"

                        text1="Yes of course"
                        color1="success"

                        correct_answer={0}

                        fail_message="Evil Corp got you to accept the terms and conditons by placing a fake hair on the screen over the button they wanted you to press, hoping you would try to flick it away. This technique was used in the wild to generate clicks for banners."
                        setResult={setResult}

                        getPos={getPos}
                    
                    ></Hair>,
                        
                    

            



                        <SneakySub 

                        types={[QuestionType.SNEAKY]}

                        position={0}
                                        
                        question="Error. This question cannot be loaded."
                        sub="Click retry to accept the terms and conditions"
                        text0="Cancel"
                        color0="danger"

                        text1="Retry"
                        color1="success"

                        correct_answer={0}

                        fail_message="Evil copr got you to agree to the terms and conditions with a fake error message."
                        setResult={setResult}

                        getPos={getPos}
                        
                        ></SneakySub>,




            
            <List 
    
            types={[QuestionType.LOGICAL]}
                      
            question="Select the one truthful statement to opt out of cookies."
            
            options={[
                "All the statements below are true.",
                "None of the statements below are true.",
                "None of the statements above are true."
               
            ]}
    
            correct_answer={2}
    
            
    
            fail_message="Evil Corp got you to turn on cookies by deliberately obfuscating the opt out button."

            setResult={setResult}
    
            getPos={getPos}
          
          ></List>,
            
    






        <ThreeButtons 

        types={[QuestionType.LOGICAL, QuestionType.LANGUAGE]}

        position={0}
                        
        question="To opt out click the button that is immediately to the left of the button that is to the right of the black button."
        text0="?"
        color0="danger"

        text1="?"
        color1="primary"

        text2="?"
        color2="danger"

        correct_answer={1}

        fail_message="Evil Corp got you to turn on cookies by deliberately obfuscating the opt out button."
        setResult={setResult}

        getPos={getPos}
        
        ></ThreeButtons>,




      
        
                <TouchDown 

                types={[QuestionType.SNEAKY]}

                    position={0}
                                    
                    question="Answer very, very carefully. Do you agree to the terms & conditions?"

                    text0="Yes"
                    color0="success"

                    text1="No"
                    color1="danger"

                    correct_answer={1}

                    fail_message="Evil Copy got you to agree to the Ts and Cs by swapping the positions of the agree and accept buttons."
                    setResult={setResult}

                    getPos={getPos}

            ></TouchDown>,
            
            
            


            <Spin 

            types={[QuestionType.EASY]}
            
            question="Almost done! Set this toggle to the ‘on’ position and hit 'I'm feeling lucky' to opt out of Cookies. If you are incorrect, the toggle will spin."
    
            num_switches={1}
    
            fail_message="Evil Copy made you agree to the Ts and Cs by making it impossible to tell if the switches are set to opt-in or opt-out. This is another technique in regular use in cookie pop ups."
                setResult={setResult}
    
                getPos={getPos}
            
            ></Spin>,
    
    
    
    
            <Spin 
    
            types={[QuestionType.LOGICAL, QuestionType.HARD]}
            
            question="Last question. Set both toggles to the ‘on’ position to opt out of Cookies."
    
            num_switches={2}
    
            fail_message="Evil Copy made you agree to the Ts and Cs by making it impossible to tell if the switches are set to opt-in or opt-out. This is another technique in regular use in cookie pop ups."
                setResult={setResult}
    
                getPos={getPos}
            
            ></Spin>,



                
                ]

  let all_questions = [

       
    
        round


      

]


//reverse questions so that they appear at the front
for(var i = 0; i < all_questions.length; i ++)
{
    all_questions[i] = all_questions[i].reverse()
}

return all_questions

};

